const ios = () => {
  if (typeof window === `undefined` || typeof navigator === `undefined`)
    return false;

  return /iPhone|iPad|iPod/i.test(
    navigator.userAgent ||
      navigator.vendor ||
      // @ts-ignore
      (window.opera && opera.toString() === `[object Opera]`)
  );
};

export default ios;
